<template>
  <div>
    <MasterLayout>
      <div class="pt-5 pb-3 pl-4 pr-3 dashboard_first_row">
        <div class="row">
          <div class="col-md-8">
            <div class="py-5 pt-5 mb-3 row align-items-center white-bg">
              <div class="col-md-1 remove-right-padding col-center-flex">
                <div class="square-icon-wrapper small sky-bg">
                  <img src="@/assets/img/list-inveeted.png" width="35" />
                </div>
              </div>
              <div class="py-1 col-md-6">
                <h4 class="primary-color font-600">
                  {{ $t("text.bLease.manageBspace") }}
                </h4>
                <p class="mt-3 light-grey-text">
                  {{ $t("text.bLease.BSdescription") }}
                </p>
              </div>
              <!-- <div class="col-md-5 flexify">
                <router-link
                  :to="{
                    name: 'CreateBranchSpace',
                    query: {
                      companyId: $route.query.companyId
                        ? $route.query.companyId
                        : this.branch.companyId,
                      branchId: $route.query.branchId
                        ? $route.query.branchId
                        : this.branch.id,
                      dealerId: $route.query.dealerId,
                      groupId: $route.query.groupId,
                      regionId: $route.query.regionId,
                    },
                  }"
                  class="mr-3 btn dealers_btn"
                  >{{ $t("text.bLease.createBS") }}
                </router-link>
              </div> -->
            </div>
          </div>
          <div class="col-md-4">
            <div class="py-4 card_container">
              <div class="card__header___text">
                <div>
                  <h3 class="text-center our_branches__header">
                    {{ $t("text.bLease.totCount") }}
                  </h3>
                  <div class="mt-3 dealer__icon__wrapper">
                    <div class="text-center dealer__icon__div">
                      <div>
                        <img src="@/assets/img/list-icon.png" width="35" />
                      </div>
                    </div>
                  </div>
                  <h3 class="mt-2 text-center our_branches__header">
                    {{ dataCount }}
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section class="pump__details__section_2">
        <div class="row add_driver_row record__expenses">
          <div class="col-md-12 col-lg-12">
            <ejs-grid
              v-show="!showLoader"
              ref="dataGrid"
              :created="refreshGrid"
              :allowPaging="true"
              :allowSorting="true"
              :pageSettings="pageSettings"
              :toolbar="toolbar"
              :searchSettings="search"
              :allowTextWrap="true"
              :allowExcelExport="true"
              :allowPdfExport="true"
              :toolbarClick="toolbarClick"
              :rowDataBound="rowDataBound"
              :locale="usedLang"
            >
              <e-columns>
                <e-column width="100" field="index" headerText="#"></e-column>
                <e-column
                  width="150"
                  field="name"
                  :headerText="$t('text.bLease.branchSpace')"
                ></e-column>
                <e-column
                  width="100"
                  field="rooms"
                  :headerText="$t('text.bLease.rooms')"
                ></e-column>
                <e-column
                  width="200"
                  field="durations"
                  :headerText="$t('text.bLease.durations')"
                ></e-column>
                <e-column
                  width="100"
                  field="isAvailable"
                  :headerText="$t('text.bLease.isAvailable')"
                ></e-column>
                <e-column
                  width="200"
                  :template="template"
                  :headerText="$t('text.actionButtons.title')"
                ></e-column>
              </e-columns>
            </ejs-grid>
            <TableLoader :showLoader="showLoader" />
          </div>
        </div>
      </section>
    </MasterLayout>
  </div>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/Branch/MasterLayout.vue";
import backgroundUrl from "@/assets/img/Credit-card-background-shallow-DOF.png";
import cardBackgroundUrl from "@/assets/img/Group393.svg";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import BranchSpacetemplate from "@/components/Templates/BranchSpace";

import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
  Resize,
} from "@syncfusion/ej2-vue-grids";
import JQuery from "jquery";
let $ = JQuery;

export default {
  title: "Branch space  :: Epump Portal",
  name: "Users",
  components: {
    MasterLayout,
    TableLoader,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport, Resize],
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      formatOptions: { type: "date", format: "dd/MM/yyyy" },
      branch: "",
      backgroundUrl,
      dataCount: 0,
      cardBackgroundUrl,
      showLoader: true,
      users: [],
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["Search", "ExcelExport", "PdfExport"],
      search: { operator: "contains", ignoreCase: true },
      template: function () {
        return {
          template: BranchSpacetemplate,
        };
      },
    };
  },
  watch: {
    branch: function (newBranch, oldBranch) {
      if (newBranch.id) {
        this.branchId = this.branch.id;
        if (this.branchId !== null) {
          this.getBranchSpace();
        }
      }
    },
  },
  created() {
    this.$eventHub.$on("branch", (branch) => {
      this.branch = branch;
      document.title = `Branch space :: ${branch.name} Retail Outlet`;
    });
  },
  mounted() {
    $(".e-input").keyup(function (e) {
      searchFun(e);
    });
    function searchFun(event) {
      var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
      var value = event.target.value;
      grid.search(value);
    }
    this.$eventHub.$on("refreshBranchSpace", () => {
      this.getBranchSpace();
    });
  },
  methods: {
    openModal($modal) {
      this.$modal.show($modal);
    },
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          let pdfExportProperties = {
            pageOrientation: "Landscape",
            fileName: "BrachSpace.pdf",
          };
          this.$refs.dataGrid.pdfExport(pdfExportProperties);
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    refreshGrid() {},
    rowDataBound: function (args) {
      if (args.data["isAvailable"] === "Yes") {
        args.row.cells[4].style.color = "green";
      } else {
        args.row.cells[4].style.color = "red";
      }
    },
    getBranchSpace() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/BranchSpace/Get/All/${this.branch.id}`,
          configObject.authConfig()
        )
        .then((response) => {
          response.data.forEach((data, index) => {
            if (data.rentDurations.length) {
              data.durations = data.rentDurations
                .map((el) => {
                  return `${el.name} - ${
                    this.branch ? this.branch.currencyCode : ""
                  }${el.durationPrice}`;
                })
                .join("  ,  ");
            } else {
              data.durations = "N/A";
            }
            data.isAvailable = data.isAvailable ? "Yes" : "No";
            data.index = index + 1;
          });
          this.dataCount = response.data.length;
          this.showLoader = false;
          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: response.data,
          });
          this.refreshGrid();
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
  },
};
</script>

<style></style>
